import {Helmet} from 'react-helmet'
import {useTranslation} from '@/translations/i18n.tsx'
import {useMe} from '@features/user/queries/useMe.ts'
import {raise} from '@utilities/helpers.ts'
import {YourAssignments} from '@features/home/components/your-assignments'
// import {YourWork} from '@features/home/components/your-work'
import {Container} from '@components/ui/container'
import {RequiredActionsSection} from '@features/home/components/required-actions-section'
import {FloorPlanBanner} from '@features/floor-plan/components/floor-plan-banner'
import {useRequiredActions} from '@features/home/queries/useRequiredActions.ts'
import {useMemo} from 'react'
import {renderRequiredActions} from '@features/home/utils.tsx'
import {isReviewerOnly} from '@features/user/utils'

export const Home = () => {
    const {
        t,
        i18n: {language}
    } = useTranslation()
    const meQuery = useMe({throwOnError: true})
    const user = meQuery.data ?? raise('user is nullish')
    const useRequiredActionsQuery = useRequiredActions()
    const requiredActions = useMemo(
        () =>
            useRequiredActionsQuery.data
                ? renderRequiredActions({
                      data: useRequiredActionsQuery.data
                      //   showInsightsCard: user.isInsightsVisible
                  })
                : [],
        [useRequiredActionsQuery.isSuccess, useRequiredActionsQuery.isStale, language]
    )

    return (
        <div className="flex h-full flex-col gap-6 pb-12 md:gap-8">
            <Container>
                <Helmet title={t('home:meta_title')} />
                <h2 className="pt-4 text-display-sm font-medium text-neutral-900 md:pt-16">
                    {t('home:hero_title', {name: user.firstName})}
                </h2>
            </Container>
            <FloorPlanBanner />
            {useRequiredActionsQuery.isFetching ? (
                <RequiredActionsSection asSkeleton requiredActions={requiredActions} />
            ) : (
                requiredActions.length > 0 && (
                    <RequiredActionsSection requiredActions={requiredActions} isReviewerOnly={isReviewerOnly(user)} />
                )
            )}
            <YourAssignments />
            {/* TODO: remove this condition when we have the feature @InsightsPage and approved by legal */}
            {/* {isInsightsVisible && <YourWork />} */}
        </div>
    )
}
